module.exports = {
      id: "phone-usage",
      viewBox: "0 0 10 14",
      url: __webpack_public_path__ + "img/icons.91580017.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }